export const BID_PRICE_DETAILS_LOADING = 'BID_PRICE_DETAILS_LOADING';
export const BID_PRICE_DETAILS_LOADING_ERROR =
  'BID_PRICE_DETAILS_LOADING_ERROR';
export const BID_PRICE_DETAILS_DATA = 'BID_PRICE_DETAILS_DATA';
export const BID_PRICE_ERROR = 'BID_PRICE_ERROR';

//control info
export const BID_PRICE_CONTROL_INFO_LOADING = 'BID_PRICE_CONTROL_INFO_LOADING';
export const BID_PRICE_CONTROL_INFO_LOADING_ERROR =
  'BID_PRICE_CONTROL_INFO_LOADING_ERROR';
export const BID_PRICE_CONTROL_INFO_DATA = 'BID_PRICE_CONTROL_INFO_DATA';
export const BID_PRICE_REMOVE_ITEM = 'BID_PRICE_REMOVE_ITEM';
export const CLEAR_BID_PRICE_CONTROL_INFO = 'CLEAR_BID_PRICE_CONTROL_INFO';

//save bid price
export const SUBMITTING_BID_PRICE_DETAILS = 'SUBMITTING_BID_PRICE_DETAILS';
export const BID_PRICE_DETAIL_SUBMIT = 'BID_PRICE_DETAIL_SUBMIT';
export const SUBMITTING_BID_PRICE_DETAILS_ERROR =
  'SUBMITTING_BID_PRICE_DETAILS_ERROR';
export const BID_PRICE_UPDATE_GRID = 'BID_PRICE_UPDATE_GRID';
export const BID_PRICE_ADD_PURCHASE_UNIT = 'BID_PRICE_ADD_PURCHASE_UNIT';
export const BID_PRICE_ADD_SEC_UNIT = 'BID_PRICE_ADD_SEC_UNIT';

//add new bid item
export const BID_PRICE_ADD_NEW_ITEM = 'BID_PRICE_ADD_NEW_ITEM';

//warehouse warning
export const BID_PRICE_WAREHOUSE_WARNING_LOADING =
  'BID_PRICE_WAREHOUSE_WARNING_LOADING';
export const BID_PRICE_WAREHOUSE_WARNING_LOADING_ERROR =
  'BID_PRICE_WAREHOUSE_WARNING_LOADING_ERROR';
export const BID_PRICE_WAREHOUSE_WARNING_DATA =
  'BID_PRICE_WAREHOUSE_WARNING_DATA';
export const RESET_WAREHOUSE_WARNING = 'RESET_WAREHOUSE_WARNING';
export const RESET_BID_PRICE_DATA = 'RESET_BID_PRICE_DATA';
export const RESET_DELETE_IDS = 'RESET_DELETE_IDS';

export const CLEAR_BID_PRICE_DATA = 'CLEAR_BID_PRICE_DATA';
export const ADD_BID_FOR_NEW_ITEM = 'ADD_BID_FOR_NEW_ITEM';



// WEBPACK FOOTER //
// ./src/pages/inventory/itemmaintenance/state/updateBidPriceDetails/types.js